<template>
  <div class="page-content">
    <div class="intro-content">
      <img src="@/assets/images/intro-bg.jpg" class="intro-bg" alt="image description"/>
      <h1>Don’t Sweat It!</h1>
      <div class="img-row">
        <div class="img-box"><img src="@/assets/images/row-img1.png" class="row-img" alt="image description"/></div>
        <div class="img-box"><img src="@/assets/images/row-img2.png" class="row-img" alt="image description"/></div>
        <div class="img-box"><img src="@/assets/images/row-img3.png" class="row-img" alt="image description"/></div>
        <div class="img-box"><img src="@/assets/images/row-img4.png" class="row-img" alt="image description"/></div>
      </div>
      <h2>Keeping Your  Cool</h2>
    </div>
    <div class="logo-row-bottom">
      <div class="logos-wrap">
        <div class="logo-holder">
          <img src="@/assets/images/ymi.png" width="112" height="43" alt="image description">
        </div>
        <div class="logo-holder">
          <img src="@/assets/images/cotton.png" width="190" height="94" alt="image description">
        </div>
      </div>
      <a href="#" class="btn-next" @click.prevent="next">
        <span>Start the game</span>
      </a>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from "vuex";

  export default {
    name: "Intro",
    methods: {
      ...mapMutations({
        next: 'nextStep',
      }),
    },
    mounted() {
      window.dispatchEvent(new Event('resize'));

      window.addEventListener("load", function(){
        document.body.classList.add('loaded');
      });
    }
  }
</script>
